{
  "appName": "صرافة العملات - الصرف",
  "brand": "مسافر",
  "notFound": "الصفحة غير موجودة",
  "backHome": "العودة إلى الرئيسية",
  "home": {
    "title": "أنظمة صرف العملات",
    "branch": "الفرع",
    "exchange": "نظام صرف عملات",
    "exchangeVip": "نظام صرف عملات (VIP)",
    "exchangeHint": "صرف بالأسعار العادية",
    "exchangeVipHint": "صرف بأسعار VIP",
    "balance": "رصيد الصندوق",
    "balanceHint": "رصيد صندوقك من كل عملة",
    "noBoxTitle": "لا يوجد صندوق مرتبط بحسابك",
    "noBoxDescription": "لا يمكنك الصرف قبل تعيين صندوق لك في هذا الفرع. تواصل مع المشرف.",
    "loadFailed": "تعذر تحميل بيانات الصرف.",
    "retry": "تحديث",
    "cashEntries": "المقبوضات والمدفوعات",
    "cashEntriesHint": "سجل ما يدخل صندوقك ويخرج منه"
  },
  "box": {
    "pickTitle": "اختيار الصندوق",
    "pickDescription": "أنت مرتبط بأكثر من صندوق. اختر الصندوق الذي تعمل عليه الآن.",
    "change": "تغيير الصندوق",
    "current": "الصندوق",
    "loading": "جاري تحميل الصناديق",
    "unavailable": "لم يعد الصندوق متاحا، اختر صندوقا آخر."
  },
  "balance": {
    "title": "رصيد الصندوق",
    "description": "رصيد صندوقك من كل عملة.",
    "refresh": "تحديث",
    "loading": "جاري تحميل الرصيد",
    "emptyTitle": "لا يوجد رصيد في الصندوق",
    "emptyDescription": "يظهر الرصيد هنا بعد تغذية الصندوق أو تنفيذ عملية صرف."
  },
  "form": {
    "convert": "تحويل العملة",
    "from": "من",
    "to": "إلى",
    "fromCurrency": "العملة المستلمة من العميل",
    "toCurrency": "العملة المدفوعة للعميل",
    "buyPrice": "سعر الشراء",
    "sellPrice": "سعر البيع",
    "amount": "المبلغ المراد تحويله",
    "convertedAmount": "المبلغ المحول",
    "finalResult": "الناتج النهائي",
    "lastPriceChange": "تاريخ آخر تعديل للعملات",
    "calculating": "جاري الحساب...",
    "resultPlaceholder": "اختر العملتين وأدخل المبلغ لعرض النتيجة.",
    "insufficientBalance": "لا يوجد رصيد كاف بهذه العملة في صندوقك.",
    "swap": "تبديل العملتين",
    "customer": "العميل",
    "phone": "رقم هاتف العميل",
    "name": "اسم العميل (اختياري)",
    "lookingUp": "جاري البحث عن العميل...",
    "customerFound": "تم العثور على العميل: {{name}}",
    "customerNotFound": "لم يتم العثور على عميل بهذا الرقم. سيتم تسجيله عند تأكيد العملية.",
    "photo": "إضافة صورة (اختياري)",
    "photoHint": "JPEG أو PNG أو WebP، حتى 5 ميغابايت.",
    "takePhoto": "التقاط صورة",
    "chooseFromGallery": "اختيار من المعرض",
    "removePhoto": "إزالة الصورة",
    "photoPreview": "صورة العميل",
    "photoTooLarge": "حجم الصورة أكبر من 5 ميغابايت.",
    "photoWrongType": "اختر صورة بصيغة JPEG أو PNG أو WebP.",
    "note": "إضافة ملاحظة (اختياري)",
    "continue": "متابعة",
    "amountRequired": "أدخل المبلغ.",
    "amountTooManyDecimals": "يسمح بخمس منازل عشرية كحد أقصى.",
    "sameCurrency": "اختر عملة مختلفة.",
    "currencyRequired": "اختر العملة.",
    "requiredNote": "الحقول المطلوبة مميزة بعلامة النجمة",
    "noCurrencies": "لا توجد عملات متاحة للصرف."
  },
  "summary": {
    "title": "ملخص العملية",
    "convert": "تحويل العملة",
    "from": "من",
    "to": "إلى",
    "finalAmount": "ناتج مبلغ الحوالة النهائي",
    "customerName": "اسم العميل",
    "customerPhone": "رقم هاتف العميل",
    "photo": "الصورة",
    "notes": "الملاحظات",
    "none": "—",
    "saveAndPrint": "حفظ و طباعة",
    "saveWithoutPrint": "حفظ من غير طباعة",
    "back": "عودة",
    "cancel": "إلغاء",
    "saving": "جاري الحفظ...",
    "uploadFailed": "تعذر رفع الصورة. حاول مرة أخرى أو أزل الصورة.",
    "saveFailed": "تعذر تنفيذ العملية."
  },
  "signature": {
    "title": "توقيع العميل (اختياري)",
    "notPresent": "العميل غير موجود",
    "notPresentHint": "لن يرسل شيء إلى التابلت، وتحفظ العملية بدون بيانات العميل وتوقيعه",
    "tablet": "جهاز التابلت",
    "chooseTablet": "اختر جهاز التابلت",
    "noTablets": "لا توجد أجهزة تابلت نشطة في هذا الفرع",
    "send": "إرسال إلى التابلت",
    "sending": "جاري الإرسال...",
    "resend": "إعادة الإرسال إلى التابلت",
    "cancelSend": "إلغاء الإرسال",
    "waiting": "بانتظار توقيع العميل",
    "online": "متصل",
    "offline": "غير متصل",
    "busy": "التابلت مشغول",
    "busyWith": "التابلت مشغول: {{system}}",
    "signed": "تم التوقيع",
    "image": "التوقيع",
    "imageFailed": "تعذر عرض التوقيع.",
    "saveFailed": "تعذر حفظ التوقيع. لم يتم حفظ العملية.",
    "saveWithout": "إلغاء التوقيع",
    "sendAgain": "يمكنك إعادة الإرسال إلى التابلت ليوقع العميل من جديد.",
    "expired": "انتهت مدة الطلب قبل أن يكمل العميل البيانات. أعد الإرسال إلى العميل.",
    "cancelled": "انتهى هذا الطلب ولم يعد متاحا."
  },
  "done": {
    "successTitle": "تمت العملية بنجاح",
    "reference": "رقم المرجع",
    "home": "الرئيسية",
    "receiptTitle": "الإيصال",
    "print": "طباعة",
    "newExchange": "عملية جديدة"
  },
  "receipt": {
    "date": "التاريخ",
    "time": "الوقت",
    "received": "المبلغ المستلم",
    "paid": "المبلغ المدفوع",
    "rate": "سعر الصرف",
    "customerName": "اسم العميل",
    "customerPhone": "هاتف العميل",
    "thanks": "شكرا لزيارتكم"
  },
  "pwa": {
    "install": "تثبيت التطبيق"
  },
  "cashEntries": {
    "title": "المقبوضات والمدفوعات",
    "loading": "جاري تحميل المقبوضات والمدفوعات",
    "receipt": "مقبوضات",
    "payment": "مدفوعات",
    "recordReceipt": "تسجيل مقبوضات",
    "recordPayment": "تسجيل مدفوعات",
    "receiptHint": "نقد يدخل صندوقك خارج عمليات الصرف، مثل تسليم من الإدارة.",
    "paymentHint": "نقد يخرج من صندوقك خارج عمليات الصرف، مثل مصاريف إدارية.",
    "type": "النوع",
    "allTypes": "جميع الأنواع",
    "number": "الرقم",
    "box": "الصندوق",
    "cashier": "أمين الصندوق",
    "date": "التاريخ",
    "currency": "العملة",
    "amount": "المبلغ",
    "description": "البيان",
    "chooseCurrency": "اختر العملة",
    "enterAmount": "أدخل المبلغ",
    "amountPositive": "يجب أن يكون المبلغ أكبر من صفر",
    "tooManyDecimals": "المبلغ يقبل خمس خانات عشرية كحد أقصى",
    "insufficient": "رصيد الصندوق غير كاف",
    "enterDescription": "أدخل البيان",
    "available": "الرصيد المتاح:",
    "empty": "لا توجد مقبوضات أو مدفوعات بعد",
    "noResults": "لا توجد حركات من هذا النوع",
    "view": "عرض الحركة رقم {{number}}",
    "detailsTitle": "تفاصيل الحركة",
    "page": "صفحة {{page}} من {{total}}",
    "previous": "السابق",
    "next": "التالي",
    "cancel": "إلغاء",
    "summaryTitle": "ملخص العملية",
    "save": "حفظ",
    "savedNumber": "رقم الحركة {{number}}",
    "backToList": "العودة إلى القائمة"
  }
}
